module.exports = __webpack_public_path__ + "static/media/LoginMain2Screen_elBackgroundimage_63109274.0086b3e2.jpg";